export default __webpack_public_path__ + "static/media/ic_placeholderModel.7fec8f0a.svg";